import React, { FC } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { styled } from '@mui/material';
import Image from 'next/image';

import AppColors from '~components/theme/styles/colors';

interface IconProps {
  height?: number | string;
  width?: number | string;
  style?: React.CSSProperties;
}

export const HelpTooltip = styled(HelpOutlineIcon)({
  fill: AppColors.neutralGrey[3],
  width: 18,
  height: 18,
});

export const IconVSTA: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/assets/VSTA.svg" height={height} width={width} />;
};

export const IconVST: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/assets/VST.svg" height={height} width={width} />;
};

export const IconETH: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/assets/eth-black.svg" height={height} width={width} priority />;
};

export const IconArbitrum: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/arbitrum.svg" height={height} width={width} />;
};

export const IconArrowBottomRight: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/arrow-diag.svg" height={height} width={width} />;
};

export const CarrotRight: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/carrot-right.svg" height={height} width={width} />;
};

export const IconCoins: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/landing/coin.svg" height={height} width={width} />;
};

export const IconHands: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/landing/hands.svg" height={height} width={width} />;
};

export const IconPiggyBank: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/landing/pig.svg" height={height} width={width} />;
};

export const IconCoinStacks: FC<IconProps> = ({ height = 40, width = 40 }) => {
  return <Image src="/img/landing/coinStack.svg" height={height} width={width} />;
};

export const IconPieChart: FC<IconProps> = ({ height = 40, width = 40 }) => {
  return <Image src="/img/landing/pie.svg" height={height} width={width} />;
};

export const IconNormalMode: FC<IconProps> = ({ height = 72, width = 72, style }) => {
  return <Image style={style} src="/img/icons/normal-mode.svg" height={height} width={width} />;
};

export const IconRecoveryMode: FC<IconProps> = ({ height = 72, width = 72, style }) => {
  return <Image style={style} src="/img/icons/recovery-mode.svg" height={height} width={width} />;
};

export const IconCollateralRatio: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/collateral-ratio.svg" height={height} width={width} />;
};

export const IconLiquidationPrice: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/liq-price.svg" height={height} width={width} />;
};

export const IconLiquidationReserve: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/liq-reserve.svg" height={height} width={width} />;
};

export const IconBorrowingFee: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/borrowing-fee.svg" height={height} width={width} />;
};

export const IconLiFinanceLogo: FC<IconProps> = ({ height = 20, width = 20 }) => {
  return <Image src="/img/partner/lifinance.svg" height={height} width={width} />;
};

export const IconSynapseLogo: FC<IconProps> = ({ height = 20, width = 20 }) => {
  return <Image src="/img/partner/synapse.png" height={height} width={width} />;
};

export const IconArbitrumLogo: FC<IconProps> = ({ height = 16, width = 16 }) => {
  return <Image src="/img/arbitrum.svg" height={height} width={width} />;
};

export const IconAcrossLogo: FC<IconProps> = ({ height = 20, width = 20 }) => {
  return <Image src="/img/partner/across.svg" height={height} width={width} />;
};

export const IconSquidLogo: FC<IconProps> = ({ height = 20, width = 20 }) => {
  return <Image src="/img/partner/squid_logo.svg" height={height} width={width} />;
};

export const IconProducts: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/sidebar/vault.svg" height={height} width={width} />;
};

export const IconPortfolio: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/sidebar/dashboard.svg" height={height} width={width} />;
};

export const IconStaking: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/sidebar/staking.svg" height={height} width={width} />;
};

export const IconRedeem: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/sidebar/redeem.svg" height={height} width={width} />;
};

export const IconClaim: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/sidebar/claim.svg" height={height} width={width} />;
};

export const IconX: FC<IconProps> = ({ height = 24, width = 24 }) => {
  return <Image src="/img/icons/x.svg" height={height} width={width} />;
};
